import {BaseSlider} from "./BaseSlider";

export class ReviewsSlider extends BaseSlider {
    constructor() {
        super('.swiper-reviews');

        this.baseSwiperOptions.breakpoints = {
            768: {
                slidesPerView: 2,
            }
        };

        this.initSlider();
    }
}